import { OfbizForm, OfbizList } from "@urbannex/ofbiz-forms";
import { CalendarContainerComponent, ConfigOptions, getColumnFieldTitles, getFields } from "@urbannex/view-containers";
import { MKTING_FORMS } from "./forms";
import { MarketingCalendarComponent } from "./marketing-calendar/marketing-calendar.component";

export const options: ConfigOptions = {
    name: "Marketing",
    title: "Marketing",
    menuAndTitleOptions: {
        path: "marketing",
        menuItems: [],
        headerTitle: "Marketing Application"
    },
    listForm: new OfbizList({
        listFormName: "ScheduledSocialMediaPosts",
        columnFieldTitles:getColumnFieldTitles("ScheduledSocialMediaPosts",MKTING_FORMS),
        emptyListMessage: "No marketing data available",
        listFormLocation: "component://kwikstore/widget/MarketingForms.xml",
        columnFields: getFields("ScheduledSocialMediaPosts",MKTING_FORMS),
        remoteFormData: {
            formData: {
                formName: "ScheduledSocialMediaPosts",
                formLocation: "component://kwikstore/widget/MarketingForms.xml",
                listType: "grid",
                entityName: "",
                viewIndex: 0,
                viewSize: 0
            }
        },
        findParameters:[
            {"noConditionFind":"Y"}
        ],
        renderComponent:CalendarContainerComponent
    }),
    findForm: new OfbizForm(),
    addForm: new OfbizForm(),
    relations:[
        {
            addContainerTitle: "",
            listContainerTitle: "",
            keyMap: undefined,
            addFormName: "",
            listFormName: "",
            title: "Social Media Posting",
            listForm: new OfbizList({
                listFormName: "socialMediaPostingList",
                columnFieldTitles:getColumnFieldTitles("SocialMediaPosting",MKTING_FORMS),
                emptyListMessage: "No social media postings available",
                listFormLocation: "SocialMediaPosting",
                columnFields: getFields("SocialMediaPosting",MKTING_FORMS),
                remoteFormData: {
                    formData: {
                        formName: "SocialMediaPosting",
                        formLocation: "component://kwikstore/widget/MarketingForms.xml",
                        listType: "grid",
                        entityName: "",
                        viewIndex: 0,
                        viewSize: 0
                    }
                }
            }),
            addForm: new OfbizForm(),
        },
        {
            addContainerTitle: "",
            listContainerTitle: "",
            keyMap: undefined,
            addFormName: "",
            listFormName: "",
            title: "Email Marketing",
            listForm: new OfbizList({
                listFormName: "emailMarketingList",
                columnFieldTitles:getColumnFieldTitles("EmailMarketing",MKTING_FORMS),
                emptyListMessage: "No email marketing data available",
                listFormLocation: "EmailMarketing",
                columnFields: getFields("EmailMarketing",MKTING_FORMS),
                remoteFormData: {
                    formData: {
                        formName: "EmailMarketing",
                        formLocation: "component://kwikstore/widget/MarketingForms.xml",
                        listType: "grid",
                        entityName: "",
                        viewIndex: 0,
                        viewSize: 0
                    }
                }
            }),
            addForm: new OfbizForm(),
        }
    ],
    masterDetails:[

    ],
    actions: [],
    settings: []
}